import {
  findRouteByName,
  Menu,
} from '@/internal';

interface Payload {
  handleTakeOffSoftwareClick: Function,
}

export default (payload: Payload) => {

  const { handleTakeOffSoftwareClick } = payload;

  return new Menu({
    menuItems: [
      {
        title: 'Takeoff Software',
        onClick: handleTakeOffSoftwareClick,
        icon: 'calculator',
        iconPack: 'fal',
      },
      {
        title: 'Update My Info',
        route: findRouteByName('company/edit'),
        icon: 'user',
        iconPack: 'fal',
      },
    ],
  });
};
